import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Site } from './site';
import { catchError, map, tap } from 'rxjs/operators';
import { RequestOptions, Headers } from '@angular/http';
import { baseUrl, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class SitesService {

  private url = baseUrl + gatewayFile;

  sites: Site[];

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getActiveBranches( ): Observable<string[]> {
    const url = `${this.url}`;
    return this.http.post<string[]>(url, { token: localStorage.getItem('token'), function: 'getAllActiveBranches' })
    .pipe(
      catchError(this.handleError('getAllActiveBranches', []))
    );
  }

  getSitesForBranch(code: string, date: string): Observable<Site[]> {
    const url = `${this.url}`;
    return this.http.post<Site[]>(url, { token: localStorage.getItem('token'), function: 'getSitesData', item1: date, item2: code })
    .pipe(
      catchError(this.handleError('getSitesForBranch', []))
    );
  }

  getAgencyRequirements(site: any) {
    const url = `${this.url}`;
    return this.http.post<any[]>(url, { token: localStorage.getItem('token'), function: 'getAgencyRequirements', item1: site })
    .pipe(
      catchError(this.handleError('getAgencyRequirements', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }

}
